(() => {
  const fixReviewScale = () => {
    document.querySelectorAll('#judgeme_product_reviews [role="img"][aria-label], .jdgm-widget [role="img"][aria-label]').forEach((element) => {
      const label = element.getAttribute('aria-label');
      if (/out of 1 stars/i.test(label)) element.setAttribute('aria-label', label.replace(/out of 1 stars/i, 'out of 5 stars'));
    });
  };
  const widget = document.getElementById('judgeme_product_reviews');
  if (widget) {
    fixReviewScale();
    new MutationObserver(fixReviewScale).observe(widget, {childList: true, subtree: true});
  }
})();

// Keep product identity aligned with the size the customer selects.
(() => {
  document.addEventListener('change', (event) => {
    const picker = event.target.closest('variant-radios, variant-selects');
    const schema = document.getElementById('ProductJsonLd');
    const source = picker && picker.querySelector('script[data-variant]');
    if (!source || !schema) return;
    try {
      const fields = Array.from(picker.querySelectorAll('fieldset'));
      const selects = Array.from(picker.querySelectorAll('select'));
      const selected = fields.length
        ? fields.map(field => field.querySelector('input:checked')?.value)
        : selects.map(select => select.value);
      const variant = JSON.parse(source.textContent).find(item =>
        item.options.every((option, index) => option === selected[index]));
      if (!variant) return;
      const sizeIndex = fields.length
        ? fields.findIndex(field => /^size\s*:/i.test(field.querySelector('legend')?.textContent.trim() || ''))
        : selects.findIndex(select => /size/i.test(select.name));
      const data = JSON.parse(schema.textContent);
      if (sizeIndex >= 0) data.size = variant.options[sizeIndex];
      if (variant.sku) { data.sku = variant.sku; data.mpn = variant.sku; }
      else { delete data.sku; delete data.mpn; }
      schema.textContent = JSON.stringify(data);
    } catch (error) { /* Preserve server-rendered schema if variant data is unavailable. */ }
  });
})();
